import axios from 'axios';
const BASE_URL = "https://3763698-lms-stage.adobeio-static.net/api/v1/web/lms-app";
export const api = axios.create({
    baseURL: BASE_URL,
});
export const setAuthToken = (token) => {
    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    else {
        delete api.defaults.headers.common['Authorization'];
    }
};
//# sourceMappingURL=api.js.map